import { listPrescriptionTemplates } from "src/components/Dashboard/Patient/PatientDetail/Tabs/prescription/api";
import { listDiagnosisNotesTemplates } from "src/components/Dashboard/Patient/PatientDetail/Tabs/notes/api";
import { setDiagnosisLabTests, setDiagnosisNotes, setDiagnosisTemplates, setPrescriptionTemplates } from "./templatesSlice";
import { listLabTestTemplates } from "src/components/Dashboard/Patient/PatientDetail/Tabs/labTest/api";
import { listDiagnosisTemplates } from "src/components/Dashboard/Patient/PatientDetail/Tabs/labTest/addLabTest/LabTestList";
import uniqid from "uniqid";

export const fetchPrescriptionTemplates = (search = "") => async (dispatch, getState) => {
    try {

        const response = await listPrescriptionTemplates(search, "");

        if (response) {
            dispatch(setPrescriptionTemplates(response));
        } else {
            console.info("No prescription templates data returned");
        }

    } catch (error) {
        console.error("Error fetching prescription templates", error);
    }
}

export const fetchDiagnosisTemplates = () => async (dispatch, getState) => {
    try {
        const response = await listDiagnosisTemplates("");

        if (response && Array.isArray(response)) {
            const responseWithIds = response.map(item => ({ ...item, id: uniqid() }))
            dispatch(setDiagnosisTemplates(responseWithIds));
        } else {
            console.info("No diagnosis templates data returned")
        }

    } catch (error) {
        console.error("Error fetching diagnosis templates", error);
    }
}

export const fetchDiagnosisNotes = () => async (dispatch, getState) => {
    try {

        const response = await listDiagnosisNotesTemplates("", "");

        if (response && Array.isArray(response)) {
            const responseWithIds = response.map(item => ({ ...item, id: uniqid() }))
            dispatch(setDiagnosisNotes(responseWithIds));
        } else {
            console.info("No diagnosis templates data returned")
        }

    } catch (error) {
        console.error("Error fetching diagnosis templates", error);
    }
}

export const fetchDiagnosisLabTests = () => async (dispatch, getState) => {
    try {
        const response = await listLabTestTemplates();

        if (response) {
            dispatch(setDiagnosisLabTests(response));
        } else {
            console.info("No diagnosis templates data returned")
        }

    } catch (error) {
        console.error("Error fetching diagnosis templates", error);
    }
}